import React from 'react'
import PropTypes from 'prop-types'

function RequestDetailModal ({ request, classes, onClose }) {
  if (!request) return null

  return (
    <div className={classes.modalOverlay} onClick={(e) => { if (e.target === e.currentTarget) onClose() }}>
      <div className={classes.modalContent}>
        <div className={classes.modalHeader}>
          <span className={classes.methodBadge} style={{ fontSize: '12px', padding: '2px 8px' }}>
            {request.method}
          </span>
          <span className={classes.modalTitle}>{request.url}</span>
          <span
            className={classes.statusBadge}
            style={{
              fontSize: '13px',
              color: request.status < 300 ? 'var(--color-success-600)' : 'var(--color-danger-600)'
            }}
          >
            {request.status}
          </span>
          {request.mocked && (
            <span className={classes.mockedTag} style={{ fontSize: '11px' }}>mock</span>
          )}
          {request.durationMs != null && (
            <span style={{ fontSize: '12px', color: 'var(--color-neutral-400)' }}>
              {request.durationMs}ms
            </span>
          )}
          <button className={classes.modalCloseBtn} onClick={onClose}>&times;</button>
        </div>
        <div className={classes.modalBody}>
          <div className={classes.modalPane}>
            <div className={classes.paneHeader}>Request Body</div>
            {request.requestBody
              ? <pre className={classes.panePre}>{JSON.stringify(request.requestBody, null, 2)}</pre>
              : <div className={classes.paneEmpty}>No request body</div>}
          </div>
          <div className={classes.modalPane}>
            <div className={classes.paneHeader}>Response Body</div>
            {request.responseBody
              ? <pre className={classes.panePre}>{JSON.stringify(request.responseBody, null, 2)}</pre>
              : <div className={classes.paneEmpty}>No response body</div>}
          </div>
        </div>
      </div>
    </div>
  )
}

RequestDetailModal.propTypes = {
  request: PropTypes.object,
  classes: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired
}

export default RequestDetailModal
